export const objectSizes = {
	small: ['Malý (0m²-50m²)'],
	medium: ['Střední (50m²-75m²)'],
	large: ['Velký (+75m²)'],
} as const

export const repeatIntervals = {
	weekly: 'Každý týden',
	biweekly: 'Každé dva týdny',
	monthly: 'Každé čtyři týdny',
} as const

export const orderStatuses = {
	created: 'Vytvořeno',
	active: 'Aktivní',
	accepted: 'Přijato',
	inProgress: 'Právě probíhá',
	completed: 'Dokončeno',
	finished: 'Hotovo',
	canceled: 'Úklid zrušen',
	backupPaymentFailed: 'Zálohová platba selhala',
	additionalPaymentFailed: 'Doplňková platba selhala',
	paymentFailed: 'Platba selhala',
} as const
